import { List } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SidebarMenuItems } from "./SidebarMenuItems";
import {
  sidebarMainMenuItems,
  sidebarBottomMenuItems,
} from "@/configuration/menu";
import { useAuthStore } from "@/contexts/useAuthStore";

interface SidebarMenuProps {
  collapsed: boolean;
  onMenuItemClick?: () => void;
  menuType?: "main" | "bottom";
}
export const SidebarMenu = ({
  collapsed,
  onMenuItemClick,
  menuType = "main",
}: SidebarMenuProps) => {
  const navigate = useNavigate();
  const [openItems, setOpenItems] = useState<Record<string, boolean>>({});
  const [selectedItem, setSelectedItem] = useState("");
  const { logout } = useAuthStore();
  const handleLogout = logout;

  const menuItems =
    menuType === "main" ? sidebarMainMenuItems : sidebarBottomMenuItems;

  return (
    <List sx={{ width: "100%" }}>
      <SidebarMenuItems
        collapsed={collapsed}
        items={menuItems}
        openItems={openItems}
        setOpenItems={setOpenItems}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        handleLogout={handleLogout}
        navigate={(path: string) => {
          setSelectedItem(
            sidebarMainMenuItems.find((item) => item.path === path)?.text || ""
          );
          navigate(path);
        }}
        onMenuItemClick={onMenuItemClick}
      />
    </List>
  );
};
